<div class="progress" [ngClass]="{ 'progress-short': short }">
  <div
    class="progress-bar progress-bar-striped progress-bar-animated"
    role="progressbar"
    aria-valuenow="100"
    aria-valuemin="0"
    aria-valuemax="100"
    style="width: 100%"
  >
    <span class="link-color">Please wait<span class="dotdotdot"></span></span>
  </div>
</div>
